import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const catalogQuickAtbSelector = createSelector(testTargetOffersSelector, offers => offers.catalogQuickAtb || Empty.Object);

export { catalogQuickAtbSelector };
